module.exports = __webpack_public_path__ + "img/hero-bg.abaa90f.webp";